module.exports = __webpack_public_path__ + "static/img/wawa1.f8991a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawa1.png
// module id = ywq4
// module chunks = 2